import { createContext, Dispatch } from 'react';
import { History } from 'history';
import { WireFormContext as WireFormContextType } from './WireFormProvider';
// @ts-ignore
import { Locale } from 'components/locale';
import { useStyles } from './utils/wire.styles';
import { DispatchActions, State } from './logic';

/**  Possible Workflows (url action params) */
export enum ActionName {
  CREATE = 'create',
  COPY = 'copy',
  MODIFY = 'modify',
  /** Create new payment from a template */
  INITIATE = 'initiate',
  /** Create new wire template */
  TEMPLATE = 'template',
  /** Using a wire payment as the basis create a new wire template */
  TEMPLATE_COPY_PAYMENT = 'template-copy-payment',
  TEMPLATE_MODIFY = 'template-modify',
  TEMPLATE_VIEW = 'template-view',
  VIEW = 'view'
}

export type PaymentType = 'domestic' | 'international';

export type WireBaseContext = {
  action: ActionName;
  bankTrace?: string;
  classes: ReturnType<typeof useStyles>;
  dispatch: Dispatch<DispatchActions>;
  history: History<{ workflowStartPath?: string }>;
  locale: Locale;
  paymentType: PaymentType;
  reduxActions: {
    setPaymentActionMessages: (
      paymentActionMessages: {
        id: number;
        title: string;
        success: boolean;
        details: { head: string; value?: string | number | boolean }[];
        records?: {}[];
      }[]
    ) => void;
    setSnackBarMessage: ({
      uid,
      message,
      type
    }: {
      uid?: number;
      message?: string;
      type?: any;
    }) => void;
  };
  state: State;
  templateCode?: string;
};

/** Used to store and share common variables in wires including useReducer state */
export const WireContext = createContext<WireBaseContext | undefined>(undefined);

/** Used to store and share only dispatch from wires useReducer */
export const WireDispatchContext = createContext<Dispatch<DispatchActions> | undefined>(undefined);

/** Used to store and share glu form context within wire */
export const WireFormContext = createContext<WireFormContextType | undefined>(undefined);
